import React, { memo, useEffect, useMemo } from 'react'
import {
    Box,
    CircularProgress,
    useTheme
} from '@mui/material'
import { Security, SecurityCategory_CategoryCode } from '../../proto/generated/security'
import { isTradeableSecurity } from '../../util/cashInstrument'
import { useDispatch, useSelector } from 'react-redux'
import { selectOrderBook } from '../../selectors/security'
import { getSecurityKey } from '../../util/security'
import { getOrderBook } from '../../services/apis/candles'
import { updateOrderBooks } from '../../reducer/security.reducer'
import MarketDepth from '../marketDepth/marketDepth'
import OrderBookOverview from '../orderBookOverview/orderBookOverview'

interface OrderBookProps {
    security: Security
}

const OrderBookDialog: React.FC<OrderBookProps> = ({ security }) => {
    const dispatch = useDispatch()
    const securityKey = useMemo(() => security ? getSecurityKey(security.exchange, security.code) : '', [security])
    const orderBook = useSelector(selectOrderBook(securityKey))
    const theme = useTheme()

    useEffect(() => {
        if (!orderBook && security) {
            getOrderBook({
                security: security,
                dispatch: dispatch
            })
                .then((result) => {
                    const orderBook = { ...result }
                    if (!orderBook.security) {
                        orderBook.security = { ...security }
                    }
                    dispatch(updateOrderBooks([orderBook]))
                })
                .catch((error) => {
                    console.error('Error fetching order book:', error)
                })
        }
    }, [orderBook, security, dispatch])

    if (!orderBook) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    width: '450px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <CircularProgress size={50} />
            </Box>
        )
    }

    return (
        <Box width="100%" padding={theme.spacing(1, 2, 0)}>
            {security.categoryCode !== SecurityCategory_CategoryCode.INDEX && (
                <MarketDepth security={security} tradeable={isTradeableSecurity(security)} />
            )}
            <Box sx={{ paddingY: 1, width: '100%' }}>
                <OrderBookOverview security={security} />
            </Box>
        </Box>
    )
}

export default memo(OrderBookDialog)
